(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form-inquiry"] && !Shopify.designMode) return;
  try {
    const select = document.querySelector('.contact-form-inquiry__select');
  if (select) {
    const textarea = select.closest('form').querySelector('textarea');
    const defaultPlaceholder = textarea ? textarea.placeholder : '';
    const placeholders = {
      astrology_reading: 'Opening September 2026\n\nI\u2019m currently deepening my study and practice. A limited number of readings will open soon. Join the waitlist for early access.\n\nPlease share your birth date, time, and place, and anything specific you\u2019d like guidance on.',
      stock_products: 'Please share your store name, location, type of business, and estimated order quantity.',
      collaboration: 'Please share your brand or platform, audience, and what you have in mind for the collaboration.',
      media: 'Please share your publication or platform, audience, and details of the feature or request, including timeline if relevant.',
      question: 'Please share your question with as much detail as possible so I can respond clearly.'
    };
    select.addEventListener('change', function() {
      if (textarea) {
        textarea.placeholder = placeholders[this.value] || defaultPlaceholder;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
